import "./RecommendedBadge.scss"


const RecommendedBadge = () => {
  return (
    <div className="badgeContainer">
      <p>Recommended</p>
      <img src="../svgs/recommended.svg" alt="icon"/>
    </div>
  );
};

export default RecommendedBadge;